// News & Updates: the changelog players open from the main menu.
// The words come straight from data/news.txt. See the note at the top of that file for the few marks it
// understands (# heading, ## smaller heading, - bullet, --- divider, **bold**, // a note nobody sees).
import newsText from '../../data/news.txt';
import { el, button, modal } from './ui.ts';

/** The text players see: the file without its "//" notes. */
const shown = newsText
  .replace(/\r\n?/g, '\n')
  .split('\n')
  .filter((line) => !line.trimStart().startsWith('//'));

/** The newest update's heading (the first # line), for the menu button. Empty if there is none. */
export const latestNews = (shown.find((l) => /^#\s+\S/.test(l)) ?? '').replace(/^#\s+/, '').trim();
/** Is there anything to read at all? */
export const hasNews = shown.some((l) => l.trim() !== '');

/** A line of text, with **bold** turned into bold. */
function inline(text: string): (Node | string)[] {
  return text.split(/(\*\*[^*]+\*\*)/g).map((part) => (/^\*\*[^*]+\*\*$/.test(part) ? el('strong', {}, part.slice(2, -2)) : part));
}

function render(): HTMLElement {
  const body = el('div', { class: 'news-body' });
  let list: HTMLElement | null = null;
  let para: string[] = [];
  const flush = () => {
    if (para.length) body.append(el('p', {}, ...inline(para.join('\n'))));
    para = [];
    list = null;
  };
  for (const raw of shown) {
    const line = raw.trimEnd();
    if (!line.trim()) flush();
    else if (/^---+\s*$/.test(line.trim())) {
      flush();
      body.append(el('hr', {}));
    } else if (/^##\s+/.test(line)) {
      flush();
      body.append(el('h3', {}, ...inline(line.replace(/^##\s+/, ''))));
    } else if (/^#\s+/.test(line)) {
      flush();
      body.append(el('h2', {}, ...inline(line.replace(/^#\s+/, ''))));
    } else if (/^\s*[-•]\s+/.test(line)) {
      if (para.length) flush();
      if (!list) {
        list = el('ul', {});
        body.append(list);
      }
      list.append(el('li', {}, ...inline(line.replace(/^\s*[-•]\s+/, ''))));
    } else {
      list = null;
      para.push(line);
    }
  }
  flush();
  if (!body.childElementCount) body.append(el('p', { class: 'muted' }, 'No news yet.'));
  return body;
}

export function showNews() {
  let close = () => {};
  close = modal(el('div', { class: 'news' }, el('h1', { class: 'news-title' }, 'News & Updates'), render(), el('div', { class: 'news-foot' }, button('Close', () => close(), 'btn-primary'))), { wide: true, className: 'news-modal' });
}
